import { FC } from "react";
import { Provider } from "react-redux";

import { authProvider, dataProvider } from "../init/firebase";
import history from "../init/history";
import storeCreation from "../redux/createStore";

export const store = storeCreation({ authProvider, dataProvider, history });

const ReduxConfig: FC = ({ children }) => {
  return <Provider store={store}>{children}</Provider>;
};

export default ReduxConfig;
